import { ActionForm } from '../hooks'

export const getDefaultValue = (): ActionForm => {
  return {
    code: '',
    title: '',
    actionCode: undefined,
    actionTitle: undefined,
    eventTitle: undefined,
    jsValue: '',
    draggableElementText: null,
    variable: null,
    eventCode: null,
    params: '',
    columnToSort: null,
    json: false,
    objectFormCode: null,
    contextMenu: null,
    targetColumns: [],
    formObject: null,
    command: null,
    redefinitionCommands: [],
    view: null,
  }
}
